import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges, OnChanges } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-social-chat-feed',
  templateUrl: './social-chat-feed.component.html',
  styleUrls: ['./social-chat-feed.component.scss'],
  standalone: false,
})
export class SocialChatFeedComponent implements OnDestroy, OnChanges {
  @Input() public moderatedChat = false;
  @Input() public hostChatSetting = false;
  @Input() public chatModerationSetting = false;
  @Input() public isUserHost = false;
  @Input() public tabSelected?: string;
  @Output() public selectedChat = new EventEmitter<string>();

  private destroyed$ = new ReplaySubject<boolean>(1);
  protected isHostFeed = false;
  protected isModerationFeed = false;

  public constructor(public chatService: ChatService) {}

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes && changes.tabSelected && changes.tabSelected.currentValue) {
      this.isHostFeed = changes.tabSelected.currentValue === 'Hosts';
      this.isModerationFeed = changes.tabSelected.currentValue === 'Moderation Log';
    }
  }
}
